import { render } from "./LocationCreate.vue?vue&type=template&id=12a3e889"
import script from "./LocationCreate.vue?vue&type=script&lang=js"
export * from "./LocationCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__